import React, {Component} from "react"
import {connect} from "react-redux";
import withStyles from "@mui/styles/withStyles";
import {withRouter} from "react-router-dom";
import {
    finish_test,
    init_questions,
    next_question,
    pause_test,
    reset_test,
    reset_timer,
    score_answer,
    set_answer,
    set_answer2,
    set_questions,
    start_timer,
    stop_timer,
    store_wrong_answers,
    TEST
} from "../actions/test";
import LinearProgress from "@mui/material/LinearProgress";
import {NormalBox} from "./NormalBox";
import {get_cluster_data, get_clusters} from "../actions/clusters";
import {Box} from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import MultiBox from "./MultiBox";
import ReactWordcloud from 'react-wordcloud';
import {getRandomInt} from "../utilities/random";
import {IconContext} from "react-icons";
import {GrCheckmark, GrClose} from "react-icons/gr";

const styles = {

    root: {
        minHeight: "calc(100vh - 121px)",
        position: "relative"
    },
    question_answer: {
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "50px 0"
    },
    buttons: {
        display: "flex",
        justifyContent: "space-around",
        maxWidth: "500px",
        margin: "0 auto"
    },
    question: {
        margin: "30px 0 20px"
    },
    button: {
        display: "block",
    },
    answers_table: {
        marginTop: 50
    },
    unselected: {
        display: "block",
        background: "#ffffff !important",
        color: "black !important",
        borderColor: "black !important"
    },
    correct_unselected: {
        display: "block",
        background: "#00ff00 !important",
        borderColor: "#00ff00 !important",
        color: "black !important"
    },
    wrong_unselected: {
        display: "block",
        background: "rgb(255,255,255) !important",
        borderColor: "rgb(0,0,0) !important",
        color: "black !important"
    },
    correct_selected: {
        display: "block",
        background: "#00ff00 !important",
        borderColor: "#00ff00 !important",
        color: "black !important"
    },
    wrong_selected: {
        display: "block",
        background: "rgb(233,17,17) !important",
        borderColor: "rgb(233,17,17) !important",
        color: "black !important"
    }
};

class Test extends Component {

    constructor(props) {
        super(props);
        this.state = {
            answers: [],
            currentAnswer: "",
            wrong_answers: []
        };
    }

    componentDidMount() {
        this.interval = setInterval(this.forceUpdate.bind(this), 500);
        if (this.props.clusters == null) {
            this.props.get_clusters();
        }
        if (!(this.props.test.cluster_id in this.props.cluster_rows)) {
            this.props.get_cluster_data(this.props.test.cluster_id);
        }
        if (this.props.test.time_for_answer) {
            this.startTimer(parseInt(this.props.test.time_for_answer));
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    initQuestions() {
        let rows;
        const all_rows = this.props.cluster_rows[parseInt(this.props.match.params.cluster_id)];
        if (this.props.test.from_last_answers) {
            rows = this.props.test.last_wrong_answers[parseInt(this.props.match.params.cluster_id)];
        } else {
            rows = this.props.cluster_rows[parseInt(this.props.match.params.cluster_id)];
        }

        rows = rows.map(row => {
            return {...row, score: 1}
        });
        rows = rows.filter(row => {
            if (row['col_' + this.props.test.source_col + '_value'] == null) {
                return false;
            }
            if (this.props.test.target_col2) {
                return row['col_' + this.props.test.target_col2 + '_value'] !== null
                    && row['col_' + this.props.test.target_col + '_value'] !== null;
            }
            return row['col_' + this.props.test.target_col + '_value'] !== null;
        });
        if (this.props.test.randomize_row_order) {
            rows = rows
                .map((a) => ({sort: Math.random(), value: a}))
                .sort((a, b) => a.sort - b.sort)
                .map((a) => a.value);
        }
        let all_answers = all_rows.map((a) => a['col_' + this.props.test.target_col + '_value'])
        rows = rows
            .map((a, i) => {
                let n = {...a};
                let other_a = [...all_answers];

                // find current question in whole pool
                const ind = all_answers.findIndex(an => an === a['col_' + this.props.test.target_col + '_value']);

                // remove current from pool
                other_a.splice(ind, 1)

                other_a = other_a
                    // shuffle all answers
                    .map((a) => ({sort: Math.random(), value: a}))
                    .sort((a, b) => a.sort - b.sort)
                    .map((a) => a.value)
                    // take 3 answers
                    // TODO tu sa da zmenit kolko moznosti sa prida okrem tej spravnej
                    .slice(0, 3);

                // add correct answer
                other_a.push(a['col_' + this.props.test.target_col + '_value'])

                //shuffle all answers again
                n.possible_answers = other_a
                    .map((a) => ({sort: Math.random(), value: a}))
                    .sort((a, b) => a.sort - b.sort)
                    .map((a) => a.value);

                return n
            });

        this.props.store_wrong_answers(parseInt(this.props.match.params.cluster_id), []);
        if (rows.length === 0) {
            this.props.reset_test();
            this.props.history.push('/clusters');
        } else {
            this.props.init_questions(rows);
        }
    }

    nextQuestion() {
        if (this.props.test.current_question + 1 >= this.props.test.questions.length) {
            // TODO: ukoncit test
            this.finishTest();
        } else {
            if (this.props.test.time_for_answer) {
                this.startTimer();
            }
            this.props.next_question();
        }
    }

    startTimer() {
        this.props.reset_timer();
        this.props.start_timer();
    }

    pauseTest() {
        this.props.pause_test();
        this.props.history.push('/clusters');
    }

    getElapsedTime(baseTime, startedAt, stoppedAt = new Date().getTime()) {
        if (!startedAt) {
            return 0;
        } else {
            return stoppedAt - startedAt + baseTime;
        }
    }

    askCurrentQuestionAgain() {
        const number_of_repeats = 2;
        if (this.props.test.questions[this.props.test.current_question].score <= 1 / Math.pow(2, number_of_repeats)) {
            return;
        }
        // push question to random location after this
        let current_question = {...this.props.test.questions[this.props.test.current_question]};
        current_question.score /= 2;
        let current_questions = [...this.props.test.questions];
        let minimal_index = this.props.test.current_question + 1 <= this.props.test.questions.length - 1 ? this.props.test.current_question + 1 : this.props.test.current_question;
        let maximal_index = this.props.test.questions.length - 1;
        let insert_index = getRandomInt(minimal_index, maximal_index);
        current_questions.splice(insert_index + 1, 0, current_question);
        this.props.set_questions(current_questions);
    }

    isAnswerCorrect() {
        if (this.props.test.current_question >= this.props.test.questions.length) {
            return false;
        }
        const answer = (this.props.test.case_sensitivity || this.props.test.test_type === "choice") ? this.props.test.answer : this.props.test.answer.toLowerCase();
        const expectedAnswer = this.props.test.case_sensitivity || this.props.test.test_type === "choice" ?
            this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.target_col + "_value"]
            :
            this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.target_col + "_value"].toLowerCase()
        ;
        return answer.localeCompare(expectedAnswer) === 0;
    }

    isSecondAnswerCorrect() {
        if (this.props.test.test_type === "choice") {
            return true;
        }
        const answer = this.props.test.case_sensitivity ? this.props.test.answer2 : this.props.test.answer2.toLowerCase();
        const expectedAnswer = this.props.test.case_sensitivity ?
            this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.target_col2 + "_value"]
            :
            this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.target_col2 + "_value"].toLowerCase()
        ;
        return answer.localeCompare(expectedAnswer) === 0;
    }

    scoreAnswer() {
        let score = 0;
        if (this.isAnswerCorrect() && (this.props.test.target_col2 === 0 || this.isSecondAnswerCorrect())) {
            score = this.props.test.questions[this.props.test.current_question].score;
        } else {
            this.askCurrentQuestionAgain();
            let last_wrong_answers = [];
            if (parseInt(this.props.match.params.cluster_id) in this.props.test.last_wrong_answers) {
                last_wrong_answers = this.props.test.last_wrong_answers[parseInt(this.props.match.params.cluster_id)];
            }
            const exists = !(last_wrong_answers.find((answer) => answer.id === this.props.test.questions[this.props.test.current_question].id) === undefined);
            if (!exists) {
                this.props.store_wrong_answers(parseInt(this.props.match.params.cluster_id), [
                    ...last_wrong_answers,
                    this.props.test.questions[this.props.test.current_question]
                ]);
            }
        }
        this.props.score_answer(score);
        setTimeout(() => {
            this.nextQuestion();
        }, score > 0 ? 1000 : 3000);
    }

    setAndScoreAnswer(answer) {
        let score = 0;
        if (answer === this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.target_col + "_value"]) {
            score = this.props.test.questions[this.props.test.current_question].score;
        } else {
            this.askCurrentQuestionAgain();
            let last_wrong_answers = [];
            if (parseInt(this.props.match.params.cluster_id) in this.props.test.last_wrong_answers) {
                last_wrong_answers = this.props.test.last_wrong_answers[parseInt(this.props.match.params.cluster_id)];
            }
            const exists = !(last_wrong_answers.find((answer) => answer.id === this.props.test.questions[this.props.test.current_question].id) === undefined);
            if (!exists) {
                this.props.store_wrong_answers(parseInt(this.props.match.params.cluster_id), [
                    ...last_wrong_answers,
                    this.props.test.questions[this.props.test.current_question]
                ]);
            }
        }
        this.props.score_answer(score);
        setTimeout(() => {
            this.nextQuestion();
        }, score > 0 ? 1000 : 3000);
    }

    onAnswerChanged(answer, targetColId) {
        if (targetColId === this.props.test.target_col) {
            this.props.set_answer(answer);
        } else if (targetColId === this.props.test.target_col2) {
            this.props.set_answer2(answer);
        }
    }

    onKeyUp(event) {
        event.preventDefault();
        if (event.key === 'Enter' && !this.props.test.evaluating) {
            this.scoreAnswer();
        }
    }

    finishTest() {
        this.props.finish_test();
        clearInterval(this.interval);
    }

    repeatTest() {
        this.initQuestions();
    }

    exitTest() {
        this.props.reset_test();
        this.props.history.push('/clusters/' + this.props.match.params.cluster_id + '/');
    }

    render() {
        const {baseTime, startedAt, stoppedAt} = this.props.test;
        const remainingTime = this.props.test.time_for_answer - Math.ceil(this.getElapsedTime(baseTime, startedAt, stoppedAt) / 1000);
        if (this.props.test.state === TEST.RUNNING && remainingTime < 0) {
            if (!this.props.test.evaluating) {
                this.scoreAnswer();
            }
        }

        if (this.props.test.state === TEST.NOT_RUNNING || this.props.test.cluster_id == null) {
            // po tom ako sa resetne alebo sa sem dostal rucne
            this.props.history.push('/clusters/' + this.props.match.params.cluster_id + '/');
            return;
        }
        if (parseInt(this.props.match.params.cluster_id) !== this.props.test.cluster_id) {
            // ak je v inom klastri ako v nakonfigurovanom
            //this.props.reset_test();
            this.props.history.push('/clusters/' + this.props.test.cluster_id + '/test');
            return;
        }

        if (this.props.clusters == null || !(this.props.test.cluster_id in this.props.cluster_rows)) {
            return <LinearProgress/>
        } else if (this.props.test.questions.length === 0) {
            this.initQuestions();
            return <LinearProgress/>
        }

        if (this.props.test.current_question >= this.props.test.questions.length) {
            if (this.props.test.state !== TEST.FINISHED) {
                this.props.finish_test();
            }
        }

        // todo this.props.set_page_title(this.props.clusters.find(cluster => cluster.id === parseInt(this.props.match.params.cluster_id)).title);

        const {classes} = this.props;

        if (this.props.test.state === TEST.FINISHED) {
            const words = [];
            this.props.test.questions.forEach((question, i) => {
                words.push({
                    text: question["col_" + this.props.test.target_col + "_value"],
                    value: 1 - this.props.test.scores[i]
                });
                words.push({
                    text: question["col_" + this.props.test.target_col2 + "_value"],
                    value: 1 - this.props.test.scores[i]
                });
            });

            return <Box className={classes.root}>
                <Box className={classes.question_answer}>
                    <Typography variant="h4"
                                component="h4"
                    >
                        You
                        achieved <span>{(this.props.test.scores.reduce((a, b) => a + b) / this.props.test.questions_at_start * 100).toFixed(2)} %</span>
                    </Typography>
                    <ReactWordcloud
                        words={words}
                        options={{
                            fontSizes: [12, 30],
                            tooltipOptions: {
                                trigger: 'manual',
                            },
                            deterministic: true
                        }}

                    />
                </Box>
                <Box className={classes.buttons}>
                    <Button variant="contained"
                            color="secondary"
                            className={classes.button}
                            autoFocus={true}
                            onClick={this.exitTest.bind(this)}>
                        Exit
                    </Button>
                    {/*<Button variant="contained"*/}
                    {/*        color="primary"*/}
                    {/*        className={classes.button}*/}
                    {/*        onClick={this.repeatTest.bind(this)}*/}
                    {/*>*/}
                    {/*    Repeat test*/}
                    {/*</Button>*/}
                </Box>
            </Box>
        }
        let correct_answer;
        if (this.props.test.target_col) {
            correct_answer = this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.target_col + "_value"];
        }
        let correct_answer2;
        if (this.props.test.target_col2) {
            correct_answer2 = this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.target_col2 + "_value"];
        }
        return (
            <Box className={classes.root}>
                <Box className={classes.question_answer} onKeyUp={this.onKeyUp.bind(this)}>
                    <Typography variant="h6"
                                component="h6"
                    >
                        Question {this.props.test.current_question + 1}/{this.props.test.questions.length}
                        {this.props.test.time_for_answer &&
                            <>
                                <br/>
                                <Typography
                                    hidden={this.props.test.evaluating}
                                    style={{color: remainingTime < 5 && 'red'}}
                                >
                                    Time left: {remainingTime || 0} seconds
                                </Typography>
                            </>
                        }
                        <br/>
                        {
                            this.props.test.evaluating &&
                            (this.isAnswerCorrect() && (this.props.test.target_col2 === 0 || this.isSecondAnswerCorrect()) ?
                                    <IconContext.Provider value={{color: 'green'}}>
                                        <GrCheckmark/>
                                    </IconContext.Provider>
                                    :
                                    <IconContext.Provider value={{color: 'red'}}>
                                        <GrClose/>
                                    </IconContext.Provider>
                            )
                        }
                        {!this.props.test.evaluating && <br/>}

                    </Typography>
                    {this.props.test.test_type === "text" && <>
                        {this.props.test.target_col2 ?
                            <table className={classes.answers_table}>
                                <tbody>
                                <tr>
                                    <td style={{fontSize: 25, paddingRight: "100px", verticalAlign: "bottom"}}>
                                        <Typography><b
                                            style={{fontSize: 25}}>{this.props.test.col_names[this.props.test.target_col]}</b></Typography>
                                    </td>
                                    <td>
                                        {this.props.test.visible_character_boxes ?
                                            <div style={{display: 'flex'}}>
                                                <MultiBox key={"q_" + this.props.test.current_question}
                                                          expectedInput={correct_answer}
                                                          targetColId={this.props.test.target_col}
                                                          onAnswerChange={this.onAnswerChanged.bind(this)}
                                                          color={this.props.test.evaluating ? (this.isAnswerCorrect() ? '#00ff00' : 'red') : null}
                                                />
                                                {
                                                    this.props.test.evaluating && !this.isAnswerCorrect() &&
                                                    <Typography>({this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.target_col + "_value"]})</Typography>
                                                }
                                            </div>
                                            :
                                            <div style={{display: 'flex'}}>
                                                <NormalBox key={"q_" + this.props.test.current_question}
                                                           onAnswerChange={this.onAnswerChanged.bind(this)}
                                                           targetColId={this.props.test.target_col}
                                                           color={this.props.test.evaluating ? (this.isAnswerCorrect() ? '#00ff00' : 'red') : null}
                                                />
                                                {
                                                    this.props.test.evaluating && !this.isAnswerCorrect() &&
                                                    <Typography>({this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.target_col + "_value"]})</Typography>
                                                }
                                            </div>
                                        }
                                    </td>
                                </tr>
                                <tr style={{height: "55px"}}>
                                    <td style={{fontSize: 25, paddingRight: "100px", verticalAlign: "bottom"}}>
                                        <Typography><b
                                            style={{fontSize: 25}}>{this.props.test.col_names[this.props.test.source_col]}</b></Typography>
                                    </td>
                                    <td style={{fontSize: 25, verticalAlign: "bottom"}}>
                                        <Typography><b
                                            style={{fontSize: 25}}>{this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.source_col + "_value"]}</b></Typography>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize: 25, paddingRight: "100px", verticalAlign: "bottom"}}>
                                        <Typography><b
                                            style={{fontSize: 25}}>{this.props.test.col_names[this.props.test.target_col2]}</b></Typography>
                                    </td>
                                    <td>
                                        {this.props.test.visible_character_boxes ?
                                            <div style={{display: 'flex'}}>
                                                <MultiBox key={"q_" + this.props.test.current_question}
                                                          expectedInput={correct_answer2}
                                                          targetColId={this.props.test.target_col2}
                                                          disableAutofocus={true}
                                                          onAnswerChange={this.onAnswerChanged.bind(this)}
                                                          color={this.props.test.evaluating ? (this.isSecondAnswerCorrect() ? '#00ff00' : 'red') : null}
                                                />
                                                {
                                                    this.props.test.evaluating && !this.isSecondAnswerCorrect() &&
                                                    <Typography
                                                        style={{whiteSpace: "nowrap"}}>({this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.target_col2 + "_value"]})</Typography>
                                                }
                                            </div>
                                            :
                                            <div style={{display: 'flex'}}>
                                                <NormalBox key={"q_" + this.props.test.current_question}
                                                           targetColId={this.props.test.target_col2}
                                                           disableAutofocus={true}
                                                           onAnswerChange={this.onAnswerChanged.bind(this)}
                                                           color={this.props.test.evaluating ? (this.isSecondAnswerCorrect() ? '#00ff00' : 'red') : null}
                                                />
                                                {
                                                    this.props.test.evaluating && !this.isSecondAnswerCorrect() &&
                                                    <Typography
                                                        style={{whiteSpace: "nowrap"}}>({this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.target_col2 + "_value"]})</Typography>
                                                }
                                            </div>
                                        }
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            :
                            <table className={classes.answers_table}>
                                <tbody>
                                <tr style={{height: "55px"}}>
                                    <td style={{fontSize: 25, paddingRight: "100px", verticalAlign: "bottom"}}>
                                        <Typography><b
                                            style={{fontSize: 25}}>{this.props.test.col_names[this.props.test.source_col]}</b></Typography>
                                    </td>
                                    <td style={{fontSize: 25, verticalAlign: "bottom"}}>
                                        <Typography><b
                                            style={{fontSize: 25}}>{this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.source_col + "_value"]}</b></Typography>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize: 25, paddingRight: "100px", verticalAlign: "bottom"}}>
                                        <Typography><b
                                            style={{fontSize: 25}}>{this.props.test.col_names[this.props.test.target_col]}</b></Typography>
                                    </td>
                                    <td>
                                        {this.props.test.visible_character_boxes ?
                                            <div style={{display: 'flex'}}>
                                                <MultiBox key={"q_" + this.props.test.current_question}
                                                          expectedInput={correct_answer}
                                                          targetColId={this.props.test.target_col}
                                                          onAnswerChange={this.onAnswerChanged.bind(this)}
                                                          color={this.props.test.evaluating ? (this.isAnswerCorrect() ? '#00ff00' : 'red') : null}
                                                />
                                                {
                                                    this.props.test.evaluating && !this.isAnswerCorrect() &&
                                                    <Typography
                                                        style={{whiteSpace: "nowrap"}}>({this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.target_col + "_value"]})</Typography>
                                                }
                                            </div>
                                            :
                                            <div style={{display: 'flex'}}>
                                                <NormalBox key={"q_" + this.props.test.current_question}
                                                           targetColId={this.props.test.target_col}
                                                           onAnswerChange={this.onAnswerChanged.bind(this)}
                                                           color={this.props.test.evaluating ? (this.isAnswerCorrect() ? '#00ff00' : 'red') : null}
                                                />
                                                {
                                                    this.props.test.evaluating && !this.isAnswerCorrect() &&
                                                    <Typography
                                                        style={{whiteSpace: "nowrap"}}>({this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.target_col + "_value"]})</Typography>
                                                }
                                            </div>
                                        }
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        }</>
                    }

                    {this.props.test.test_type === "choice" && <>
                        <Typography style={{marginBottom: 15}}><b
                            style={{fontSize: 25}}>{this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.source_col + "_value"]}</b></Typography>

                        <div style={{display: "flex", flexDirection: "column", alignItems: "stretch"}}>
                            {this.props.test.questions[this.props.test.current_question].possible_answers.map((q, i) =>
                                <Button variant="outlined" style={{marginBottom: 15}}
                                        key={"answer-" + i}
                                        size="large"
                                        disabled={this.props.test.evaluating}
                                        className={(this.props.test.evaluating ?
                                                (
                                                    this.props.test.questions[this.props.test.current_question]["col_" + this.props.test.target_col + "_value"] === q ?
                                                        (this.props.test.answer === q ?
                                                            this.props.classes.correct_selected
                                                            :
                                                            this.props.classes.correct_unselected)
                                                        :
                                                        (this.props.test.answer === q ?
                                                            this.props.classes.wrong_selected
                                                            :
                                                            this.props.classes.wrong_unselected)
                                                )
                                                :
                                                classes.unselected
                                        )}
                                        onClick={() => {
                                            this.props.set_answer(q);
                                            // this.scoreAnswer();
                                            this.setAndScoreAnswer(q);
                                        }}>
                                    {q}
                                </Button>)}
                        </div>
                    </>}
                </Box>
                <Box className={classes.buttons}>
                    <Button variant="contained"
                            color="secondary"
                            className={classes.button}
                            onClick={this.exitTest.bind(this)}>
                        Cancel
                    </Button>
                    <Button
                        className={classes.button} onClick={this.pauseTest.bind(this)} variant="contained"
                        style={{marginLeft: 10, background: "rgb(0, 0, 204)", color: "white"}}>
                        Pause
                    </Button>
                    <Button variant="contained"
                            disabled={this.props.test.evaluating}
                            color="primary"
                            className={classes.button}
                            onClick={this.scoreAnswer.bind(this)}>
                        Next question
                    </Button>
                </Box>
            </Box>
        )
    }
}

const mapStateToProps = state => ({
        test: state.test,
        clusters: state.clusters.clusters,
        cluster_rows: state.clusters.cluster_rows
    }
);

export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    {
        get_clusters,
        get_cluster_data,
        reset_test,
        init_questions,
        next_question,
        score_answer,
        finish_test,
        set_answer,
        set_answer2,
        set_questions,
        start_timer,
        stop_timer,
        reset_timer,
        pause_test,
        store_wrong_answers
    }
)(Test)));
